import { VerificationRouteStatus } from 'constants/verification'
import { type VerificationRouteStatus as VerificationRouteStatusType } from 'types/verification'
import { HighNetWorthFormData } from './schemas/highNetWorthSchema'
import { RestrictedFormData } from './schemas/restrictedSchema'
import { SophisticatedFormData } from './schemas/sophisticatedSchema'
import { FinpromResultType, FinpromVerificationStepKey, SelfCategorisationCategory } from './types'

export const finpromCoolOffPreferenceKey = 'isUkInvestmentRiskAccepted'
export const finpromVerificationStepsPreferenceKey = 'finpromVerificationStepStatus'
export const finpromSelfCategorisationPreferenceKey = 'finpromSelfCategorisation'

export type FinpromCoolOffStatus = Date | boolean
export type FinpromVerificationStepsStatus = Record<
  FinpromVerificationStepKey,
  VerificationRouteStatusType
>

export type SelfCategorisationAnswers =
  | RestrictedFormData
  | HighNetWorthFormData
  | SophisticatedFormData

export type SelfCategorisationData = {
  category: SelfCategorisationCategory
  answers?: SelfCategorisationAnswers
  result?: FinpromResultType
}

export interface FinpromAccountPreferenceData {
  [finpromCoolOffPreferenceKey]?: FinpromCoolOffStatus
  [finpromVerificationStepsPreferenceKey]?: FinpromVerificationStepsStatus
  [finpromSelfCategorisationPreferenceKey]?: SelfCategorisationData
}

export const initialFinpromVerificationStepsStatus: FinpromVerificationStepsStatus = {
  riskWarning: VerificationRouteStatus.COMPLETED,
  selfCategorisation: VerificationRouteStatus.PENDING,
  appropriatenessTest: VerificationRouteStatus.PENDING,
}
